import { BASE_PLAN_SUB_TYPES, planTypes, PBX_CATEGORYS } from '@/common/constants';
import { getCartInfo } from '@/common/service/default-mapper';
import _, { get as _get } from 'lodash';
import { $config } from '@/global-install/index';

export default (raw) => {
  const path = $config('enableNewProPlus') ? `zoomone.zoom-workplace-pro-plus` : `zoomone.zoom-one-pro-plus`;
  const plans = _get(raw, path, []);
  return plans.reduce((acc, x) => {
    const category = x.category_code;
    const parent_category = x.parent_category;
    const pbxCategory = _.chain(category)
      .upperCase()
      .replace(_.upperCase(parent_category), '')
      .value();

    const plan = {
      type: planTypes.ZONE_PRO_PLUS,
      category,
      pbxCategory,
      zoomMeetingCategory: BASE_PLAN_SUB_TYPES.ZOOM_ONE_PRO_PLUS,
      plan_code: x.plan_code,
      plan_type: x.plan_type,
      amount: x.amount,
      region: x.region,
      billing_cycle: x.billing_cycle,
      parent_category: x.parent_category,
      cartInfo: getCartInfo(),
      supportCoupon: true,
      dependBasePlanTypeList: [],
      typeNameKey: 'billing.zone_pro_plus.title',
      planNameKey: 'billing.zone_pro_plus.title',
      defaultPbxBase: PBX_CATEGORYS.ZVP,
    };
    return [...acc, plan];
  }, []);
};
